import React from 'react';
import { LoaderSpinProps, LoaderSpin } from './LoaderSpin';
import { AdminLayout } from '../layout/AdminLayout';
import { FrontLayout } from '../layout/FrontLayout';

export interface LoadingPageProps extends LoaderSpinProps {
  isAdmin?: boolean;
}

/**
 * Pagina di caricamento.
 */
export function LoadingPage(props: LoadingPageProps) {
  const { isAdmin, ...otherProps } = props;

  if (isAdmin)
    return (
      <AdminLayout>
        <LoaderSpin {...otherProps} transparent />
      </AdminLayout>
    );

  return (
    <FrontLayout>
      <LoaderSpin {...otherProps} transparent />
    </FrontLayout>
  );
}
